import React, {Component} from 'react'
import ContactForm from './ContactForm'

class ContactIndex extends Component {
    render() {
        return (
            <div id="contactIndex">
                <div id="heroContact">
                    <div id="heroContactInfo"  className="card">
                        <h1 style={{textAlign: 'center', color: 'white'}}>GET STARTED TODAY <span role="img" aria-label="envelope"> ️✉️</span></h1>
                        <div id="heroContactInfoForm">
                            <ContactForm />
                        </div>
                    </div>
                </div>
                <br/>
                <div id="contactDirect" className="card">
                    <h1>Call Us</h1>
                    <a href="tel:+17326329690" style={{textDecoration: 'none', color: 'black', fontSize: '125%'}}><i className="fa fa-phone" aria-hidden="true" />  +1-732-632-9690</a>
                    <h1 style={{color: 'whitesmoke'}}>Email Us</h1>
                    <a href="mailto:info@unique-tutorials.com" style={{textDecoration: 'none', color: 'whitesmoke', fontSize: '125%'}}><i className="fa fa-envelope" aria-hidden="true" /> info@unique-tutorials.com</a>
                </div>
            </div>
        )
    }
}

export default ContactIndex